"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionProvider = void 0;
var CollectionProvider = /** @class */ (function () {
    function CollectionProvider() {
    }
    CollectionProvider.isCollectionProvider = function (c) {
        return typeof c.getCollections === 'function';
    };
    CollectionProvider.getCollections = function (c) {
        var collections = [];
        c.forEachField(function (field) {
            if (!CollectionProvider.isCollectionProvider(field)) {
                return;
            }
            var fieldCaptures = field.getCollections() || [];
            for (var _i = 0, fieldCaptures_1 = fieldCaptures; _i < fieldCaptures_1.length; _i++) {
                var fieldCapture = fieldCaptures_1[_i];
                collections.push(fieldCapture);
            }
        });
        return collections;
    };
    CollectionProvider.getCollectionIds = function (c) {
        var collections = [];
        c.forEachField(function (field) {
            if (!CollectionProvider.isCollectionProvider(field)) {
                return;
            }
            var fieldCaptures = field.getCollectionIds() || [];
            for (var _i = 0, fieldCaptures_2 = fieldCaptures; _i < fieldCaptures_2.length; _i++) {
                var fieldCapture = fieldCaptures_2[_i];
                collections.push(fieldCapture);
            }
        });
        return collections;
    };
    return CollectionProvider;
}());
exports.CollectionProvider = CollectionProvider;
//# sourceMappingURL=collection.provider.js.map